const { h, render, Component } = require('preact');

class OtherIssuesView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const showFbLink = Groupon.Utils.getConfigFromDom().fbOrderContactsEnabled;
    return (
      <div class="other-issues">
        <p>
          {I18n.translate("js.modules.web_2018.other_issues")}
        </p>
        { showFbLink && (
            <span onClick={this.props.handleFacebookOrderHelp} data-bhw="web2018_facebook_order_contacts_logged_out_link">
              {I18n.translate("js.modules.web_2018.facebook_order_contacts")}
            </span>
          )
        }
        { showFbLink && <br/> }
        <span onClick={this.props.handleUnableToSignIn} data-bhw="web2018_unable_to_sign_in_link">
          {I18n.translate("js.modules.web_2018.unable_to_sign_in")}
        </span>
        <br/>
        <span onClick={this.props.handleReportSuspiciousActivity} data-bhw="web2018_report_suspicious_activity_link">
          {I18n.translate("js.modules.web_2018.report_suspicious_activity")}
        </span>
      </div>
    );
  }
}
module.exports = OtherIssuesView
